(() => {
  const CHECKOUT_ORIGIN = "https://checkout.evolene.shop";
  const PRODUCT_IMAGE = "https://cdn.shopify.com/s/files/1/1105/8069/5389/files/17.webp?v=1789093310";
  const OFFERS = {
    "uk-buy1-onetime": { bottles: 1, price: 3495, compare: 3495, frequency: "Buy 1", currency: "GBP", subscription: false, gifts: false },
    "uk-buy2-get1-onetime": { bottles: 3, price: 3995, compare: 3995, frequency: "Buy 2 + Get 1 Free", currency: "GBP", subscription: false, gifts: false },
    "uk-buy3-get2-onetime": { bottles: 5, price: 5495, compare: 5495, frequency: "Buy 3 + Get 2 Free", currency: "GBP", subscription: false, gifts: false },
    "buy1-onetime": { bottles: 1, price: 3995, compare: 3995, frequency: "1 bottle", subscription: false, gifts: false },
    "buy2-get1-onetime": { bottles: 3, price: 4495, compare: 4495, frequency: "Buy 2 + Get 1 Free", subscription: false, gifts: false },
    "buy3-get2-onetime": { bottles: 5, price: 5995, compare: 5995, frequency: "Buy 3 + Get 2 Free", subscription: false, gifts: false },
    "once-subscription": { bottles: 1, price: 4495, compare: 5000, frequency: "1× Per Day", subscription: true, gifts: false },
    "once-onetime": { bottles: 1, price: 5000, compare: 5000, frequency: "1× Per Day", subscription: false, gifts: false },
    "twice-subscription": { bottles: 2, price: 4995, compare: 7000, frequency: "2× Per Day", subscription: true, gifts: true },
    "twice-onetime": { bottles: 2, price: 7000, compare: 7000, frequency: "2× Per Day", subscription: false, gifts: false },
    "thrice-subscription": { bottles: 3, price: 6995, compare: 10000, frequency: "3× Per Day", subscription: true, gifts: true },
    "thrice-onetime": { bottles: 3, price: 10000, compare: 10000, frequency: "3× Per Day", subscription: false, gifts: false },
  };
  const GIFTS = [
    { name: "Gua Sha", value: "10,00 €", image: "https://cdn.shopify.com/s/files/1/1105/8069/5389/files/gua_sha.webp?v=1788115641" },
    { name: "Facial Roller", value: "9,00 €", image: "https://cdn.shopify.com/s/files/1/1105/8069/5389/files/face_roller.webp?v=1788115641" },
    { name: "Cooling Roller", value: "12,00 €", image: "https://cdn.shopify.com/s/files/1/1105/8069/5389/files/ice_roller.webp?v=1788115641" },
  ];
  const ATTRIBUTION_STORAGE_KEY = "evolene_attribution_v1";
  const preloadedCheckouts = new Map();
  const preloadRequests = new Map();

  function readCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const value = document.cookie.split(";").map((part) => part.trim()).find((part) => part.startsWith(prefix));
    return value ? decodeURIComponent(value.slice(prefix.length)) : "";
  }

  function captureAttribution() {
    let saved = {};
    try { saved = JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_STORAGE_KEY) || "{}"); } catch { saved = {}; }
    const current = new URL(window.location.href);
    const captured = {
      ...saved,
      landing_page: saved.landing_page || current.toString(),
      referrer: saved.referrer || document.referrer || "",
      fbp: readCookie("_fbp") || saved.fbp || "",
      fbc: readCookie("_fbc") || saved.fbc || "",
    };
    current.searchParams.forEach((value, key) => {
      if (key.startsWith("utm_") || ["fbclid", "gclid", "a"].includes(key)) captured[key] = value;
    });
    try { window.sessionStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(captured)); } catch { /* Storage can be unavailable in privacy mode. */ }
    return captured;
  }

  function formatMoney(cents, currency = "GBP") {
    return new Intl.NumberFormat(currency === "GBP" ? "en-GB" : "fr-FR", {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(cents) / 100);
  }

  function offerIdFor(selection) {
    if (selection.offerId && OFFERS[selection.offerId]) return selection.offerId;
    const prefix = { once: "once", twice: "twice", three: "thrice" }[selection.frequency];
    return `${prefix}-${selection.purchaseMode === "subscription" ? "subscription" : "onetime"}`;
  }

  function evoleneLines(cart) {
    return (cart.items || []).flatMap((item) => {
      const offerId = item.properties?._evolene_offer_id;
      const offer = OFFERS[offerId];
      if (!offer || item.quantity < 1 || item.quantity % offer.bottles !== 0) return [];
      return [{ item, offerId, offer, lots: item.quantity / offer.bottles }];
    });
  }

  async function fetchCart() {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" }, cache: "no-store" });
    if (!response.ok) throw new Error("Unable to load your basket.");
    return response.json();
  }

  function ensureCartDrawer() {
    let drawer = document.querySelector("[data-ev-cart-drawer]");
    if (drawer) return drawer;
    drawer = document.createElement("div");
    drawer.className = "ev-cart-drawer";
    drawer.dataset.evCartDrawer = "true";
    drawer.hidden = true;
    drawer.innerHTML = `
      <button class="ev-cart-drawer__overlay" type="button" aria-label="Close basket" data-ev-cart-close></button>
      <aside class="ev-cart-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="EvCartTitle">
        <header class="ev-cart-drawer__header">
          <div><p class="ev-cart-drawer__eyebrow">YOUR BASKET</p><h2 id="EvCartTitle">90-day money-back guarantee</h2></div>
          <button class="ev-cart-drawer__close" type="button" aria-label="Close basket" data-ev-cart-close>×</button>
        </header>
        <div class="ev-cart-drawer__shipping"><span>✓</span> Free shipping included</div>
        <div class="ev-cart-drawer__body"><div data-ev-cart-products></div>
          <section class="ev-cart-drawer__gifts" data-ev-cart-gifts>
            <p class="ev-cart-drawer__gifts-title">FREE GIFTS :</p><div class="ev-cart-drawer__gift-list"></div>
          </section>
        </div>
        <footer class="ev-cart-drawer__footer">
          <div class="ev-cart-drawer__subtotal"><span data-ev-cart-subtotal-label>Subtotal</span><strong data-ev-cart-subtotal></strong></div>
          <a class="ev-cart-drawer__checkout" data-ev-cart-checkout>SECURE CHECKOUT</a>
        </footer>
      </aside>`;
    const giftList = drawer.querySelector(".ev-cart-drawer__gift-list");
    GIFTS.forEach((gift) => {
      const row = document.createElement("div");
      row.className = "ev-cart-drawer__gift";
      row.innerHTML = `<img src="${gift.image}" alt="" width="54" height="54"><span><b></b><small><s></s> FREE</small></span><strong>FREE</strong>`;
      row.querySelector("b").textContent = gift.name;
      row.querySelector("s").textContent = gift.value;
      giftList.appendChild(row);
    });
    drawer.querySelectorAll("[data-ev-cart-close]").forEach((button) => button.addEventListener("click", closeCartDrawer));
    drawer.addEventListener("click", async (event) => {
      const remove = event.target.closest?.("[data-ev-cart-remove]");
      if (!remove) return;
      remove.disabled = true;
      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: remove.dataset.evCartRemove, quantity: 0 }),
        });
        if (!response.ok) throw new Error("Unable to remove this item.");
        await renderCartDrawer(await response.json());
      } catch (error) {
        console.error(error);
        remove.disabled = false;
      }
    });
    document.body.appendChild(drawer);
    return drawer;
  }

  function setCartBubbleCount(count) {
    const bubble = document.querySelector("#cart-icon-bubble");
    if (!bubble) return;
    let status = bubble.querySelector(".cart-count-bubble");
    if (count < 1) { status?.remove(); return; }
    if (!status) {
      status = document.createElement("div");
      status.className = "cart-count-bubble";
      status.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      bubble.appendChild(status);
    }
    status.querySelector("[aria-hidden=true]").textContent = String(count);
    status.querySelector(".visually-hidden").textContent = `${count} item${count > 1 ? "s" : ""} in your basket`;
  }

  function checkoutCartKey(lines) {
    return lines.map(({ offerId, lots }) => `${offerId}:${lots}`).join(",");
  }

  function checkoutAttribution() {
    const attribution = captureAttribution();
    return {
      landingPage: attribution.landing_page || window.location.href,
      referrer: attribution.referrer || document.referrer || undefined,
      userAgent: navigator.userAgent,
      utmSource: attribution.utm_source || undefined,
      utmMedium: attribution.utm_medium || undefined,
      utmCampaign: attribution.utm_campaign || undefined,
      utmContent: attribution.utm_content || undefined,
      utmTerm: attribution.utm_term || undefined,
      fbclid: attribution.fbclid || undefined,
      fbp: attribution.fbp || undefined,
      fbc: attribution.fbc || undefined,
      gclid: attribution.gclid || undefined,
    };
  }

  function checkoutUrl(lines, preloadToken) {
    const url = new URL(CHECKOUT_ORIGIN);
    url.searchParams.set("cart", checkoutCartKey(lines));
    url.searchParams.set("shipping", "express");
    const attribution = captureAttribution();
    Object.entries(attribution).forEach(([key, value]) => {
      if (!value) return;
      const checkoutKey = { landing_page: "ev_landing", referrer: "ev_referrer", fbp: "ev_fbp", fbc: "ev_fbc" }[key] || key;
      url.searchParams.set(checkoutKey, String(value).slice(0, 500));
    });
    if (preloadToken) url.searchParams.set("preload", preloadToken);
    return url.toString();
  }

  function preloadCheckout(lines) {
    const key = checkoutCartKey(lines);
    const cached = preloadedCheckouts.get(key);
    if (cached && cached.expiresAt > Date.now() + 30_000) return Promise.resolve(cached);
    if (preloadRequests.has(key)) return preloadRequests.get(key);
    const request = fetch(`${CHECKOUT_ORIGIN}/api/checkout/preload`, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        cart: lines.map(({ offerId, lots }) => ({ offerId, quantity: lots })),
        shippingId: "express",
        attribution: checkoutAttribution(),
      }),
    }).then(async (response) => {
      if (!response.ok) throw new Error("Checkout preload unavailable");
      const result = await response.json();
      if (typeof result.token !== "string" || !Number.isFinite(result.expiresAt)) throw new Error("Invalid checkout preload response");
      preloadedCheckouts.set(key, result);
      return result;
    }).catch(() => null).finally(() => preloadRequests.delete(key));
    preloadRequests.set(key, request);
    return request;
  }

  async function renderCartDrawer(cart) {
    const drawer = ensureCartDrawer();
    const lines = evoleneLines(cart);
    const container = drawer.querySelector("[data-ev-cart-products]");
    container.replaceChildren();
    if (!lines.length) {
      const empty = document.createElement("p");
      empty.className = "ev-cart-drawer__empty";
      empty.textContent = "Your basket is empty.";
      container.appendChild(empty);
    }
    const currencies = new Set(lines.map(({ offer }) => offer.currency || "EUR"));
    const mixedCurrency = currencies.size > 1;
    const cartCurrency = [...currencies][0] || "GBP";
    if (mixedCurrency) {
      const notice = document.createElement("p");
      notice.textContent = "Your basket contains previous euro offers. Please remove them to check out with the new UK offers.";
      container.appendChild(notice);
    }
    let subtotal = 0;
    lines.forEach(({ item, offerId, offer, lots }) => {
      subtotal += offer.price * lots;
      const article = document.createElement("article");
      article.className = "ev-cart-drawer__product";
      article.innerHTML = `
        <div class="ev-cart-drawer__image-wrap"><img src="${PRODUCT_IMAGE}" alt="Evolène™ - Anti-Hair Growth Serum" width="112" height="112"><span>${offer.bottles * lots}</span></div>
        <div class="ev-cart-drawer__product-copy"><h3>Evolène™ - Anti-Hair Growth Serum</h3><p>${offer.bottles * lots} bottle${offer.bottles * lots > 1 ? "s" : ""} · ${offer.frequency}</p><p class="ev-cart-drawer__cycle"${!offer.subscription && lots === 1 ? " hidden" : ""}>${offer.subscription ? "Delivery every 28 days" : ""}${lots > 1 ? `${offer.subscription ? " · " : ""}${lots} bundles` : ""}</p><button type="button" data-ev-cart-remove="${item.key}" aria-label="Remove item"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5"/></svg></button></div>
        <div class="ev-cart-drawer__price"><s${offer.compare === offer.price ? " hidden" : ""}>${formatMoney(offer.compare * lots, offer.currency || "EUR")}</s><strong>${formatMoney(offer.price * lots, offer.currency || "EUR")}</strong></div>`;
      article.dataset.offerId = offerId;
      container.appendChild(article);
    });
    drawer.querySelector("[data-ev-cart-gifts]").hidden = !lines.some(({ offer }) => offer.gifts);
    const itemCount = cart.item_count || 0;
    drawer.querySelector("[data-ev-cart-subtotal-label]").textContent = `Subtotal (${itemCount} item${itemCount > 1 ? "s" : ""})`;
    drawer.querySelector("[data-ev-cart-subtotal]").textContent = mixedCurrency ? "—" : formatMoney(subtotal, cartCurrency);
    const checkout = drawer.querySelector("[data-ev-cart-checkout]");
    checkout.hidden = lines.length === 0 || mixedCurrency;
    if (lines.length && !mixedCurrency) {
      const key = checkoutCartKey(lines);
      checkout.dataset.evPreloadKey = key;
      checkout.href = checkoutUrl(lines);
      void preloadCheckout(lines).then((preload) => {
        if (!preload || checkout.dataset.evPreloadKey !== key) return;
        checkout.href = checkoutUrl(lines, preload.token);
      });
    } else {
      delete checkout.dataset.evPreloadKey;
      checkout.removeAttribute("href");
    }
    checkout.textContent = `CHECKOUT — ${formatMoney(subtotal, cartCurrency)}`;
    setCartBubbleCount(cart.item_count || 0);
    return drawer;
  }

  async function openCartDrawer(existingCart) {
    try {
      const cart = existingCart || await fetchCart();
      const drawer = await renderCartDrawer(cart);
      drawer.hidden = false;
      requestAnimationFrame(() => drawer.classList.add("is-open"));
      document.body.classList.add("ev-cart-open");
      drawer.querySelector(".ev-cart-drawer__close").focus();
    } catch (error) {
      console.error(error);
    }
  }

  function closeCartDrawer() {
    const drawer = document.querySelector("[data-ev-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.body.classList.remove("ev-cart-open");
    window.setTimeout(() => { if (!drawer.classList.contains("is-open")) drawer.hidden = true; }, 220);
  }

  async function clearCompletedCart() {
    const url = new URL(window.location.href);
    const paymentId = url.searchParams.get("evolene_checkout_complete");
    if (!/^pay_[A-Za-z0-9]+$/.test(paymentId || "")) return;
    try {
      const response = await fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } });
      if (response.ok) setCartBubbleCount(0);
    } finally {
      url.searchParams.delete("evolene_checkout_complete");
      window.history.replaceState({}, "", url.toString());
    }
  }

  class EvoleneBundleSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.frequencyInputs = Array.from(this.querySelectorAll('input[name^="ev-frequency-"]'));
      this.offerInputs = Array.from(this.querySelectorAll('input[name^="ev-offer-"]'));
      this.productInfo = this.closest("product-info");
      this.productForm = this.productInfo?.querySelector("product-form");
      this.form = this.productForm?.querySelector('form[data-type="add-to-cart-form"]');
      this.submitButton = this.form?.querySelector('[name="add"]');
      this.status = this.querySelector("[data-ev-status]");
      this.productInfo?.classList.add("ev-bundle-enabled");
      this.frequencyInputs.forEach((input) => input.addEventListener("change", () => this.update(true)));
      this.offerInputs.forEach((input) => input.addEventListener("change", () => this.update(false)));
      this.prepareCartButton();
      this.update(true);
      fetchCart().then((cart) => setCartBubbleCount(cart.item_count || 0)).catch(() => {});
    }

    get selectedFrequency() { return this.frequencyInputs.find((input) => input.checked) || this.frequencyInputs[0]; }
    get selectedOffer() { if (this.dataset.offerVersion === "one-time-bundles") return "one_time"; return this.offerInputs.find((input) => input.checked)?.value || "subscription"; }

    update(switchMedia) {
      const frequency = this.selectedFrequency;
      if (!frequency) return;
      if (this.dataset.offerVersion === "one-time-bundles") {
        const selection = this.selection();
        this.syncForm(selection);
        const label = this.submitButton?.querySelector("span");
        if (label) {
          label.textContent = `ADD TO CART · ${formatMoney(selection.displayedPrice)}`;
          const unit = document.createElement("small");
          unit.className = "ev-button-unit";
          unit.textContent = `(${formatMoney(Math.round(selection.displayedPrice / selection.quantity))} per bottle)`;
          label.appendChild(unit);
        }
        if (this.status) this.status.textContent = `${OFFERS[selection.offerId].frequency}, one-time purchase, ${formatMoney(selection.displayedPrice)}.`;
        return;
      }
      const quantity = Number(frequency.dataset.quantity);
      const subscriptionPrice = Number(frequency.dataset.subscriptionPrice);
      const oneTimePrice = Number(frequency.dataset.oneTimePrice);
      const saving = Number(frequency.dataset.saving);
      this.querySelector("[data-ev-subscription-price]").textContent = formatMoney(subscriptionPrice);
      this.querySelector("[data-ev-subscription-compare]").textContent = formatMoney(oneTimePrice);
      this.querySelector("[data-ev-one-time-price]").textContent = formatMoney(oneTimePrice);
      this.querySelector("[data-ev-saving-badge]").textContent = `-${saving} %`;
      this.querySelector("[data-ev-banner-saving]").textContent = `${saving} %`;
      this.querySelector("[data-ev-banner-gift-copy]").hidden = saving === 10;
      this.querySelector("[data-ev-shipping-benefit]").textContent = frequency.value === "once"
        ? "Free shipping"
        : "3 free gifts + free shipping";
      const welcomeKit = this.querySelector("[data-ev-welcome-kit]");
      if (welcomeKit) welcomeKit.hidden = frequency.value === "once";
      this.syncForm(this.selection());
      if (switchMedia) this.switchGalleryMedia(frequency.value);
      if (this.status) {
        const frequencyLabel = frequency.closest("label")?.querySelector(".ev-bundle__frequency-title")?.textContent.trim();
        const price = this.selectedOffer === "subscription" ? subscriptionPrice : oneTimePrice;
        this.status.textContent = `${frequencyLabel}, ${this.selectedOffer === "subscription" ? "subscription every 28 days" : "one-time purchase"}, ${formatMoney(price)}.`;
      }
    }

    selection() {
      const frequency = this.selectedFrequency;
      const purchaseMode = this.selectedOffer;
      return {
        offerId: frequency.dataset.offerId,
        frequency: frequency.dataset.offerId ? "twice" : frequency.value,
        frequencyLabel: frequency.closest("label")?.querySelector(".ev-bundle__frequency-title")?.textContent.trim() || "",
        quantity: Number(frequency.dataset.quantity),
        purchaseMode,
        displayedPrice: Number(purchaseMode === "subscription" ? frequency.dataset.subscriptionPrice : frequency.dataset.oneTimePrice),
        oneTimePrice: Number(frequency.dataset.oneTimePrice),
      };
    }

    syncForm(selection) {
      if (!this.form) return;
      const offerId = offerIdFor(selection);
      this.setHiddenInput("quantity", String(selection.quantity));
      this.setHiddenInput("properties[Fréquence d’application]", selection.frequency);
      this.setHiddenInput("properties[Type d’achat]", selection.purchaseMode);
      this.setHiddenInput("properties[Prix affiché]", formatMoney(selection.displayedPrice));
      this.setHiddenInput("properties[_evolene_offer_id]", offerId);
      this.setHiddenInput("properties[_evolene_bottles]", String(selection.quantity));
    }

    setHiddenInput(name, value) {
      let input = Array.from(this.form.elements).find((element) => element.name === name);
      if (!input) {
        input = document.createElement("input"); input.type = "hidden"; input.name = name; input.dataset.evBundleInput = "true"; this.form.appendChild(input);
      }
      input.value = value;
    }

    switchGalleryMedia(frequency) {
      const mediaId = this.dataset[`media${frequency.charAt(0).toUpperCase()}${frequency.slice(1)}`];
      if (!mediaId) return;
      const gallery = document.getElementById(`MediaGallery-${this.dataset.sectionId}`);
      if (!gallery) return;
      if (typeof gallery.setActiveMedia !== "function") {
        customElements.whenDefined("media-gallery").then(() => {
          if (this.isConnected && typeof gallery.setActiveMedia === "function") gallery.setActiveMedia(mediaId, false);
        });
        return;
      }
      gallery.setActiveMedia(mediaId, false);
    }

    prepareCartButton() {
      if (!this.submitButton || !this.form) return;
      const label = this.submitButton.querySelector("span");
      if (label) label.textContent = "ADD TO CART";
      this.submitButton.type = "submit";
      this.submitButton.disabled = false;
      this.submitButton.removeAttribute("disabled");
      this.submitButton.removeAttribute("aria-disabled");
      this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.form.addEventListener("submit", async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        const selection = this.selection();
        this.syncForm(selection);
        this.submitButton.setAttribute("aria-disabled", "true");
        this.submitButton.classList.add("loading");
        try {
          const formData = new FormData(this.form);
          const response = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
            body: formData,
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || "Unable to add this item.");
          window.whop?.track?.("add_to_cart", {
            value: selection.displayedPrice / 100,
            currency: OFFERS[selection.offerId]?.currency || "EUR",
          });
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: formData.get("id"), cartData: result });
          }
          const cart = await fetchCart();
          const lines = evoleneLines(cart);
          if (!lines.length) throw new Error("Unable to prepare your basket. Please try again.");
          await openCartDrawer(cart);
        } catch (error) {
          console.error(error);
          if (this.status) this.status.textContent = error instanceof Error ? error.message : "Unable to add this item.";
        } finally {
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
        }
      }, true);
    }
  }

  document.addEventListener("keydown", (event) => { if (event.key === "Escape") closeCartDrawer(); });
  document.addEventListener("click", (event) => {
    const link = event.target.closest?.("a[href]");
    if (!link) return;
    const destination = new URL(link.href, window.location.href);
    const storefrontRoute = destination.origin === window.location.origin;
    const path = destination.pathname.replace(/\/+$/, "") || "/";
    const cartPath = new URL(window.routes?.cart_url || "/cart", window.location.origin).pathname.replace(/\/+$/, "") || "/";
    const isShopifyCart = storefrontRoute && path === cartPath;
    const isShopifyCheckout = storefrontRoute && (/(^|\/)checkout$/.test(path) || path.includes("/checkouts/"));
    if (!isShopifyCart && !isShopifyCheckout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void openCartDrawer();
  }, true);
  document.addEventListener("submit", (event) => {
    const form = event.target.closest?.("form[action]");
    if (!form) return;
    const destination = new URL(form.action, window.location.href);
    const path = destination.pathname.replace(/\/+$/, "") || "/";
    const cartPath = new URL(window.routes?.cart_url || "/cart", window.location.origin).pathname.replace(/\/+$/, "") || "/";
    if (destination.origin !== window.location.origin || path !== cartPath) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void openCartDrawer();
  }, true);

  captureAttribution();
  void clearCompletedCart();
  const initialUrl = new URL(window.location.href);
  if (initialUrl.searchParams.get("evolene_cart") === "open") {
    initialUrl.searchParams.delete("evolene_cart");
    window.history.replaceState({}, "", initialUrl.toString());
    void openCartDrawer();
  }
  if (!customElements.get("evolene-bundle-selector")) customElements.define("evolene-bundle-selector", EvoleneBundleSelector);
})();
